import { render, staticRenderFns } from "./CourseIter.vue?vue&type=template&id=7b8a56cc&scoped=true&"
import script from "./CourseIter.vue?vue&type=script&lang=ts&"
export * from "./CourseIter.vue?vue&type=script&lang=ts&"
import style0 from "./CourseIter.vue?vue&type=style&index=0&id=7b8a56cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a56cc",
  null
  
)

export default component.exports